import calculateInvestPayoutTrans from "./calculate_invest_payouts";
import endOfTurnTaxCalculation from "./end_of_turn_tax_calculation";
import { moveFromCashToSavings } from "./move_from_cash_to_savings";
import calculateMoodPoints from "../objects/calculate_mood_points";
import createInvestPayoutText from './create_invest_payout_text';
import rollForwardDate from "../objects/roll_forward_date_function";
import rollForwardCash from "../objects/roll_forward_cash_function";
import endOfMonthSpendHistory from "./end_of_month_spend_history";
import getCurrentPriceArr from "../../moneyBuilder/xMoneyBuilderObjects/get_current_price_arr";
import createNotificationForCDMatures from "./create_notification_for_CD_matures";

export const closeOutThisTurn = (gameData, totalNbrGameMonths, timeWizard, savingsInfo,
    nbrMonths, creditCardActive, investmentMaster, gameInvestments) => {

    let estimatedMonthlyExp = 0;
    let notificationArr = [];
    let additionalMoodPoints = 0; 
    calculateMoodPoints(0, true, gameData.currentMoodPoints, gameData.moodPointHistory);
    //  the following initializes data required by the calculateInvestPayoutTrans routine
    let gameInvestUpdtArr = [];
    let totalPayoutArr = [];
    let bondHistoryArr = [];
    let investHistoryArr = [];
    let totalRegularTaxAmt = 0;
    let totalCapitalTaxAmt = 0;
    let totalSavingsTaxAmt = 0;
    let investCashAmt = 0;
    let savingsTranArr = [];
    let currentPriceArr = [];
    let archiveSavingTrans = false;
    const taxDate = gameData.currentGameDate;
    let investPayoutInformation = {};
    // initialize fields used in the moveFromCashToSavings
    let savingsCashAmt = 0;
    const savingsArr = savingsInfo.savingsArr;
    let updateSavings = false;
    for (let counter = 0; counter<nbrMonths; counter++){
        //  investment processing starts here
        if (gameInvestments.length > 0){
            const monthNbr = +totalNbrGameMonths - +gameData.gameNbrMonths;
            investPayoutInformation = calculateInvestPayoutTrans(gameData.currentGameDate, monthNbr,
                gameInvestments, investmentMaster, gameData.assetTable, gameInvestUpdtArr, 
                bondHistoryArr, investHistoryArr);
            totalPayoutArr = totalPayoutArr.concat(investPayoutInformation.payoutArr);
            totalRegularTaxAmt += investPayoutInformation.regularTaxAmt;
            totalCapitalTaxAmt += investPayoutInformation.capitalTaxAmt;
        }    
        // even if the savings feature is not active, still need to update the interest earned
        if (savingsInfo.gameID){ 
            if (savingsInfo.currentlyActive || savingsInfo.totalSavingsAmt > 0) {
                currentPriceArr = getCurrentPriceArr(gameData.gameNbrMonths);
                let savingsObj = moveFromCashToSavings(savingsArr, gameData.currentGameDate,
                    gameData.assetTable, currentPriceArr, savingsInfo.companyMatchRate, savingsInfo.gameID,
                    savingsTranArr);
                savingsCashAmt += savingsObj.cashAmt;
                savingsInfo.savingsArr = savingsObj.savingsArr;
                totalSavingsTaxAmt += savingsObj.taxAmt;
                savingsTranArr = savingsObj.savingsTranArr;
                updateSavings = true;
            }
        }
        gameData.currentGameDate =
                rollForwardDate(gameData.currentGameDate, 1);
        gameData.gameNbrMonths -= 1;
        const currentGameMonth = gameData.currentGameDate.split("-")[1];
        if (currentGameMonth === "01"){
            archiveSavingTrans = true;
        }
    }
    if (savingsInfo.savingsArr){
        const savingsCDObj = savingsInfo.savingsArr.find(elem => elem.savingsType === "CD");
        if (savingsCDObj){
            const checkDate = JSON.parse(JSON.stringify(gameData.currentGameDate));
            //  if CD certficate is going to mature during next period then create notification
            createNotificationForCDMatures(checkDate, nbrMonths, notificationArr, savingsCDObj.CDList);
        }
    }
    if (totalPayoutArr.length > 0){
        investCashAmt = createInvestPayoutText(totalPayoutArr, true, gameData.iconTable, "investPayout").cashChg;
    }
    let federalTaxAmt = 0;
    if (totalRegularTaxAmt !== 0 || totalCapitalTaxAmt !== 0 || totalSavingsTaxAmt !== 0){
        federalTaxAmt = endOfTurnTaxCalculation(totalRegularTaxAmt, totalCapitalTaxAmt, 
            totalSavingsTaxAmt, notificationArr, taxDate);
    }
    gameData.gameNbrMonths = gameData.gameNbrMonths.toString();
    // Update cash based on monthly income/expenses and subtract 1 from nbrMonths for asset, 
    // expense, loan table items
    let monthlyAmounts = rollForwardCash(gameData.assetTable, gameData.expenseTable,
        gameData.loanTable, gameData.currentGameDate, creditCardActive, timeWizard, 
        );
    const spendHistory = endOfMonthSpendHistory(monthlyAmounts.totalExpCashAmt, 
        monthlyAmounts.totalExpChargeAmt, monthlyAmounts.totalLoanPayments, gameData.spendingHistory, 
        nbrMonths);
    gameData.spendingHistory = spendHistory.spendHistory;
    const invalidArr = spendHistory.invalidArr;
     
    const returnObj = {gameInvestUpdtArr: gameInvestUpdtArr, gameInvestments: gameInvestments,
        investPayoutInformation: investPayoutInformation, investCashAmt: investCashAmt, 
        savingsCashAmt: savingsCashAmt, updateSavings: updateSavings, savingsTranArr: savingsTranArr,
        federalTaxAmt: federalTaxAmt, monthlyCashAmt: monthlyAmounts.totalCashChange,
        estimatedMonthlyExp: estimatedMonthlyExp, additionalMoodPoints: additionalMoodPoints,
        invalidArr: invalidArr, currentPriceArr: currentPriceArr, archiveSavingTrans: archiveSavingTrans,
        notificationArr: notificationArr
    }
    return returnObj;
}

export default closeOutThisTurn;